import { API_BASE } from '@/shared/services/api';
import { useTranslation } from "react-i18next";import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/components/ui/card';
import { Badge } from '@/shared/components/ui/badge';
import { Button } from '@/shared/components/ui/button';
import { Progress } from '@/shared/components/ui/progress';
import { ExternalLink, MapPin, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';

const API_URL = API_BASE;

export const ActiveRoutes = () => {const { t } = useTranslation("ezparcel");
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRoutes = async () => {
      try {
        const token = localStorage.getItem('ezerpToken');
        const response = await fetch(`${API_URL}/api/ezparcel/dispatch-board`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
          const data = await response.json();
          setRoutes(data.routes || []);
        }
      } catch (err) {
        console.error('Failed to fetch routes:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchRoutes();
  }, []);

  if (loading) {
    return (
      <Card className="card-elevated">
        <CardHeader>
          <CardTitle className="text-lg font-semibold">{t("activeRoutes", "Active Routes")}</CardTitle>
        </CardHeader>
        <CardContent className="flex justify-center py-8">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </CardContent>
      </Card>);

  }

  return (
    <Card className="card-elevated">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="text-lg font-semibold">{t("activeRoutes", "Active Routes")}</CardTitle>
        <Link to="/routes">
          <Button variant="ghost" size="sm">{t("viewAll", "View all")}

            <ExternalLink className="ml-2 h-4 w-4" />
          </Button>
        </Link>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {routes.length === 0 ?
          <p className="text-center text-muted-foreground py-4">{t("noActiveRoutes", "No active routes")}</p> :
          routes.map((route) => {
            const progress = route.completedStops && route.totalStops ?
            route.completedStops / route.totalStops * 100 :
            0;
            return (
              <Link
                key={route.id}
                to={`/routes/${route.id}`}
                className="block">
                <div className="p-4 rounded-lg border border-border hover:bg-muted/50 transition-colors">
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <h4 className="font-medium text-sm">{route.name || route.id}</h4>
                      <p className="text-xs text-muted-foreground mt-1">{t("driver", "Driver:")}
                        {route.driver || 'Unassigned'}
                      </p>
                    </div>
                    <Badge className="status-badge status-in-progress">{t("inProgress", "In Progress")}

                    </Badge>
                  </div>
                  <div className="space-y-2">
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-muted-foreground">{t("progress", "Progress")}</span>
                      <span className="font-medium">
                        {route.completedStops}/{route.totalStops}{t("stops", "stops")}
                      </span>
                    </div>
                    <Progress value={progress} className="h-2" />
                    <div className="flex items-center gap-4 text-xs text-muted-foreground">
                      <span className="flex items-center gap-1">
                        <MapPin className="h-3 w-3" />
                        {route.totalDistance}
                      </span>
                      <span>{route.estimatedDuration}</span>
                    </div>
                  </div>
                </div>
              </Link>);

          })}
        </div>
      </CardContent>
    </Card>);

};